import { render, staticRenderFns } from "./commande.vue?vue&type=template&id=6d0f63a7&"
import script from "./commande.vue?vue&type=script&lang=js&"
export * from "./commande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports